import React from 'react';
import { Box, Typography, Paper, TextField } from '@mui/material';

const ClinicianStudentCard = ({
  clinicianName,
  clinicianNpi,
  studentName,
  onFieldChange,
  disableNpiInput = false,
}) => {
  const handleNpiChange = (event) => {
    if (typeof onFieldChange === 'function') {
      onFieldChange('clinicianNpi', event.target.value);
    }
  };

  

  return (
    <Paper
      elevation={2}
      sx={{
        p: 3,
        borderRadius: 3,
        backgroundColor: '#e9eaff',
        fontFamily: 'Lato, sans-serif',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          gap: 2,
        }}
      >
        {/* Clinician */}
        <Box
          sx={{
            backgroundColor: 'white',
            color: 'black',
            px: 3,
            py: 2,
            borderRadius: 2,
            flex: 1,
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          }}
        >
          <Typography
            variant='subtitle2'
            sx={{ fontWeight: 700, color: '#9291f0' }}
          >
            Clinician Name
          </Typography>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              flexWrap: { xs: 'wrap', sm: 'nowrap' },
              mt: 1,
            }}
          >
            <Typography variant='h6' sx={{ fontWeight: 600 }}>
              {clinicianName || '—'}
            </Typography>
            <TextField
              label='NPI'
              placeholder='Enter NPI'
              value={clinicianNpi || ''}
              onChange={handleNpiChange}
              size='small'
              sx={{ width: { xs: '100%', sm: 180, minWidth: 250 }, flexShrink: 0 }}
              InputLabelProps={{ shrink: true }}
              inputProps={{
                maxLength: 10,
                inputMode: 'numeric',
                pattern: '[0-9]*',
              }}
              disabled={disableNpiInput}
            />
          </Box>
        </Box>

        {/* Student */}
        <Box
          sx={{
            backgroundColor: 'white',
            color: 'black',
            px: 3,
            py: 2,
            borderRadius: 2,
            flex: 1,
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          }}
        >
          <Typography
            variant='subtitle2'
            sx={{ fontWeight: 700, color: '#9291f0' }}
          >
            Student Name
          </Typography>
          <Typography variant='h6' sx={{ fontWeight: 600, mt: 1 }}>
            {studentName || '—'}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default ClinicianStudentCard;
